import React from "react";
import { useNavigate } from "react-router-dom";

interface NavMenuProps {
  closeMenu: () => void;
}

const NavMenu: React.FC<NavMenuProps> = ({ closeMenu }) => {
  const navigate = useNavigate();

  const goToPastEvent = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    closeMenu();
    navigate("/", { replace: false });
    setTimeout(() => {
      const element = document.getElementById("past-event");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  return (
    <div className="navmenu">
      <a href="/our-team" onClick={closeMenu}>Our Team</a>
      <a href="/success-in-motion" onClick={closeMenu}>Success in Motion</a>
      <a href="/#past-event" onClick={goToPastEvent}>Past Event</a>
    </div>
  );
};

export default NavMenu;
